import { render } from "./AddEvaluation.vue?vue&type=template&id=08db240b"
import script from "./AddEvaluation.vue?vue&type=script&lang=js"
export * from "./AddEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__